import { useLocation } from 'react-router-dom';

export function useActiveLink(path: string, deep = true) {
  const { pathname } = useLocation();

  const checkPath = path.startsWith('#');

  const normalActive = !checkPath && pathname === path;

  const deepActive = !checkPath && pathname.includes(path);

  return deep ? deepActive : normalActive;
}
